import { Component, EventEmitter, OnInit } from '@angular/core';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ChartDataset, ChartOptions, ChartType } from 'chart.js';
import {
  CombosConfiguration,
  FunctionsService,
  HttpService,
  MenuBreadCrumb,
  MessageService,
  params,
} from 'brainloper-ui';
import { Equipment } from 'app/models2/maintenance/equipment';
import { Indicator } from 'app/models2/indicators/indicator';

@Component({
  selector: 'app-indicators-fuel',
  templateUrl: './indicators-fuel.component.html',
  styleUrls: ['./indicators-fuel.component.scss'],
})
export class IndicatorsFuelComponent implements OnInit {

  constructor(
    private message: MessageService,
    private http: HttpService,
    private functions: FunctionsService
  ) {}

  async ngOnInit() {
  
  }
}
